import mapKeys from 'lodash/mapKeys'
import mapValues from 'lodash/mapValues'

export default landingCtrl

/** @ngInject */
function landingCtrl($scope, $uibModal, $timeout, $state, $stateParams, $q, DeviceChecker, PermPermissionStore,
gaEventsService, TariffResource, ReferencesService, ErrorCatcher) {
    $scope.gaEventsService = gaEventsService
    $scope.active = 0
    $scope.isMobile = DeviceChecker.isMobile
    $scope.navCollapsed = true
    $scope.navbarOffsetBegin = 100
    $scope.navbarOffsetEnd = 100
    $scope.specialOffer = {
        isSponsor: localStorage.sponsorId,
        isPromo: localStorage.promoId,
    }
    let tariffInfoPromise = $q.resolve({})
    let availablePowersPromise = $q.resolve({})

    $scope.toogleNavCollapsed = function () {
        if (DeviceChecker.isMobile()) {
            $scope.navCollapsed = !$scope.navCollapsed
        }
        return true
    }

    $scope.openContactModal = () => {
        $uibModal.open({
            animation: true,
            controller: 'contactModalCtrl',
            template: require('../contactModal/contactModal.jade')(),
            resolve: {
                contractSelected() {
                    return undefined
                },
                userInfo(ApiService) {
                    return __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
                    .then(() => ApiService.fetchUserInfo())
                    .catch(() => ({})))
                },
            },
        })
    }

    $scope.openFonctionnementCagnotteModal = () => {
        $uibModal.open({
            animation: true,
            size: 'lg',
            template: require('./modal/modal-fonctionnement-cagnotte.jade')(),
            controller($scope, $uibModalInstance, gaEventsService) {
                $scope.close = $uibModalInstance.dismiss
                const activate = () => gaEventsService.newEvent('open modal - Fonctionnement Cagnotte')
                activate()
            },
        })
    }

    $scope.openTransitionEnergetiqueModal = () => {
        $uibModal.open({
            animation: true,
            size: 'lg',
            template: require('./modal/modal-transition-energetique.jade')(),
            controller($scope, $uibModalInstance, gaEventsService) {
                $scope.close = $uibModalInstance.dismiss
                const activate = () => gaEventsService.newEvent('open modal - Transition Energetique')
                activate()
            },
        })
    }

    $scope.openPriceModal = () => {
        $uibModal.open({
            animation: true,
            size: 'lg',
            component: 'priceModal',
            resolve: {
                tariffInfo: tariffInfoPromise,
                availablePowers: availablePowersPromise,
            },
        })
    }

    $scope.openSubscriptionModal = () => {
        $uibModal.open({ animation: true, component: 'subscriptionModal' })
    }

    $scope.openQuotation = () => {
        $state.go('quotationDefault')
    }

    const activate = function () {
        availablePowersPromise = ReferencesService.getRefPromise('ot-ps').catch((error) => {
            ErrorCatcher.catchError(error)
            $q.reject(error)
        })

        tariffInfoPromise = TariffResource.getTariff().$promise.then((result) => {
            const toUpperCaseKey = (val, key) => key.toUpperCase()
            return mapValues(result, (val) => mapKeys(val, toUpperCaseKey))
        }).catch((error) => {
            ErrorCatcher.catchError(error)
            $q.reject(error)
        })

        $timeout(() => {
            if ($stateParams.shouldOpenPriceForm) {
                $scope.openPriceModal()
            }
        })
    }

    activate()
}

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/states/landing/landing.js